import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Card, CardBody, Col, Row } from "reactstrap";
// Pages Components
import Miniwidget from "./Miniwidget";
//import MonthlyEarnings from "./montly-earnings";
import EmailSent from "./email-sent";
import MonthlyEarnings2 from "./montly-earnings2";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { Delete, MoreVert } from "@mui/icons-material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getItemPOList, getDashboardData, getPOList } from "../../api";
import { AmountCell } from "../../components/CustomComponents/AmountCell";
import useAuth from "../../hooks/useAuth";
import { getClientWithIdReq } from "../../service/clientService";
import { getPrFavoritesListReq, getPurchaseRequisitionListReq, removeFromFavouriteReq } from "../../service/purchaseRequisitionService";
import { getPurchaseOrderListReq } from "../../service/purchaseService";
import { MODULES_ENUM, PERMISSIONS_ENUM, USER_TYPES_ENUM } from "../../utility/constants";
import RequireUserType from '../../routes/middleware/requireUserType';
import { formatDate } from "../../utility/formatDate";
import { formatNumberWithCommasAndDecimal } from "../Invoices/invoiceUtil";
import OrderStatusRenderer from "../Orders/OrderStatusRenderer";
import OrderGraph from "./order-graph";
import "./styles/Dashboard.scss";
import { useTransition } from "react";
import DateFilter from "../../components/CustomComponents/DateFilter";
import { getOrdersListCountReq } from "../../service/orderService";
// import AgreementPdfComponent from "./AgreementPdfComponent";

const Dashboard = (props) => {
  document.title = "Willsmeet Portal";
  let navigate = useNavigate();


  const breadcrumbItems = [{ title: "Dashboard", link: "#" }];
  //fetch user from local
  const user = JSON.parse(localStorage.getItem("user"))

  const [inputValue, setInputValue] = useState('');
  const [rowData, setRowData] = useState([]);
  const [chipData, setChipData] = useState([
    {
      title: 'Total Purchase Requisitions',
      total: 0,
    },
    {
      title: 'Total Purchase Orders',
      total: 0,
    },
    {
      title: 'Pending Purchase Requisitions',
      total: 0,
    },
    {
      title: 'Pending Purchase Orders',
      total: 0,
    },
    {
      title: 'Approved Purchase Requisitions',
      total: 0,
    },
    {
      title: 'Approved Purchase Orders',
      total: 0,
    },
  ]);


 const getDefaultYearDateRange = () => {
  const today = new Date();

  const fyStartYear =
    today.getMonth() >= 3
      ? today.getFullYear()
      : today.getFullYear() - 1;

  const start = new Date(fyStartYear, 3, 1); 
  start.setHours(0, 0, 0, 0);

  const end = new Date(); 
  end.setHours(23, 59, 59, 999);

  return {
    start: start.toISOString(),
    end: end.toISOString(),
  };
};
  const { selectedBranche,selectedWarehouses} = useAuth();
  const [clientData, setClientData] = useState({});
  const [topItems, setTopItems] = useState([]);
  const [topItemsLoading, setTopItemsLoading] = useState(false);
  const [favourites, setFavourites] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const defaultDateRange = useRef(getDefaultYearDateRange())
  const [date, setDate] = useState(() => defaultDateRange.current)
  const skipDateEffect = useRef(true)

  const toggleOptionsMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  const handleDeleteFromFavorites = async (orderId) => {
    try {
      setOpenMenuId(null);
      const response = await removeFromFavouriteReq(orderId);

      if (response?.success === true) {
        setFavourites(prevFavourites =>
          prevFavourites.filter(item => item?.purchaseOrder?._id !== orderId)
        );
        notify('Success', "Removed from favorites");
      } else {
        notify('Error', 'Failed to remove from favorites');
      }
    } catch (error) {
      console.error("Error removing from favorites:", error);
      notify('Error', 'Failed to remove from favorites');
    }
  };

  const redirectToViewPage = (id) => {
    let path = `/purchase-orders/${id}`;
    setTimeout(() => {
      navigate(path, id);
    }, 300);
  };

  const handleViewClick = (id) => {
    redirectToViewPage(id.order_id);
  };

  const handleDeleteResponse = (response) => {
    if (response.success === true) {
      notify('Success', response.message);
    } else {
      notify('Error', response.message);
    }
    getPurchaseOrderListData();
  };

  const redirectToEditPage = (id) => {
    let path = `/purchase-orders/${id.order_id}/edit`;
    setTimeout(() => {
      navigate(path);
    }, 300);
  };

  const handleEditClick = (id) => {
    redirectToEditPage(id);
  };

  const notify = (type, message) => {
    if (type === 'Error') {
      toast.error(message, {
        position: 'top-center',
        theme: 'colored',
      });
    } else {
      toast.success(message, {
        position: 'top-center',
        theme: 'colored',
      });
    }
  };

  const getMonthName = (monthIndex) => {
    const months = [
      'January', 'February', 'March', 'April',
      'May', 'June', 'July', 'August',
      'September', 'October', 'November', 'December'
    ];
    return months[monthIndex];
  }

  const getOrdinal = (day) => {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1: return `${day}st`;
      case 2: return `${day}nd`;
      case 3: return `${day}rd`;
      default: return `${day}th`;
    }
  }
  //filter the data based on dates
  const filterByDate = (data) => {
    return data.filter(item => {
      const created = new Date(item.createdAt || item.
        created_time)
      return (
        created >= new Date(date.start) &&
        created <= new Date(date.end)
      );
    });
  };

  const ordinalFormatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const monthName = getMonthName(date.getMonth());
    const ordinalDay = getOrdinal(date.getDate());

    return `${ordinalDay} ${monthName} ${year}`;
  };

  const getPOData = (POStatus) => {
    const {
      sent,
      accepted,
      approved,
      draft,
      published,
      deleted,
      declined,
      rejected,
    } = POStatus;

    if(user?.userType === USER_TYPES_ENUM.ADMIN) {
      return {
        total: sent + accepted + declined,
        pending: sent,
      }
    }
    return {
      total:published + accepted + declined+rejected+sent,
      pending: published,
    }
  }

  const getPRData = (PRStatus) => {
    const {
      draft,
      published,
      approved,
      rejected,
    } = PRStatus;

    return {
      total: approved + draft + published+rejected,
      pending: draft + published,
    }
  }

  const getSOData=(salesOrderStatus)=>{
    const {
      draft,
      open,
      closed
    }=salesOrderStatus
    return {
      total:draft+open+closed,
      pending:draft+open,
    }
  }

  const getPurchaseOrderStatusList = async () => {
    try {
      //getting the po&pr data 
      const response = await getDashboardData({
        startDate: date.start,
        endDate: date.end,
        branchId: selectedBranche,
        warehouseId:selectedWarehouses
      });

      const { PRStatus, POStatus,salesOrderStatus } = response.payload;

      const PRData = getPRData(PRStatus);
      const POData = getPOData(POStatus);
      const SOData=getSOData(salesOrderStatus);
      

      const startDate = encodeURIComponent(date.start);
      const endDate = encodeURIComponent(date.end);
      const newChipData = [];

      if (user?.userType === USER_TYPES_ENUM.ADMIN) {
        newChipData.push(
          {
            title: "Total Ongoing Orders",
            total: SOData.total,
            link: `/ongoing-orders?status=draft,open,closed&startDate=${startDate}&endDate=${endDate}`,
          },
          {
            title: "Total Purchase Orders",
            total: POData.total,
            link: `/reports/by-po?status=declined,sent,accepted&startDate=${startDate}&endDate=${endDate}`,
          },
          {
            title: "Pending Ongoing Orders",
            total: SOData.pending,
            link: `/ongoing-orders?status=draft,open&startDate=${startDate}&endDate=${endDate}`,
          },
          {
            title: "Pending Purchase Orders",
            total: POData.pending,
            link: `/reports/by-po?status=sent&startDate=${startDate}&endDate=${endDate}`,
          },
        );
      }

      if (user?.userType === USER_TYPES_ENUM.CLIENT) {
        newChipData.push(
          {
            title: "Total Purchase Requisitions",
            total: PRData.total,
            link: `/reports/customer-pr?startDate=${startDate}&endDate=${endDate}`,
          },
          {
            title: "Total Purchase Orders",
            total: POData.total,
            link: `/reports/customer-po?startDate=${startDate}&endDate=${endDate}`,
          },
          {
            title: "Pending Purchase Requisitions",
            total: PRData.pending,
            link: `/reports/customer-pr?status=published,draft&startDate=${startDate}&endDate=${endDate}`,
          },
          {
            title: "Pending Purchase Orders",
            total: POData.pending,
            link: `/reports/customer-po?status=published&startDate=${startDate}&endDate=${endDate}`,
          },
          
         
        );
      }

      setChipData([...newChipData]);
    } catch (error) {
      console.error("Error:", error);
    }
  };


  const searchClient = async (id) => {
    try {
      const data = { _id: id };
      const res = await getClientWithIdReq(data);

      setClientData(res.payload?.client);
    } catch (error) {
      console.log(error);
    }
  };

  const getorders = async () => {
    const items = await getPurchaseRequisitionListReq()
  }

  const getPrFavoritesList = async () => {
    try {
      const response = await getPrFavoritesListReq()

      const uniqueFavourites = Array.from(
        new Map(response.data.map(item => [item?.purchaseOrder?._id, item])).values()
      )

      setFavourites(uniqueFavourites)
    } catch (error) {
      console.error("Error fetching favourites:", error)
      setFavourites([])
    }
  }
  const onDateChange = (data) => {
    skipDateEffect.current = false;
    setDate(data);
  };

  useEffect(() => {
    getorders()
    getPrFavoritesList()
  }, [])

  const getPurchaseOrderListData = async () => {
    try {
      const response = await getPOList(
        {
          startDate: date.start,
          endDate: date.end,
          statusIn: user?.userType === "admin" ? ['accepted'] : [],
          statusNotIn: user?.userType === "client" ? ['declined'] : [],
          page: 1,
          limit: 5,
          branchId: selectedBranche,
          warehouseId:selectedWarehouses,
          clientId: user?.userType === 'client' ? JSON.parse(localStorage.getItem('user')).clientId : '',
        }
      );

      if (!response.success) {
        console.error('Unexpected response format:', response);
        return;
      }
      const newData = response.payload.data.map((order) => ({
        order_id: order.id,
        order_number: order.poNumber || '-',
        createdAt: formatDate(order.poDate),
        approvedAt:formatDate(order.approvedAt),
        Warehouse_name:order.warehouse||"HSR",
        
        order_status: order.poStatus,
        branch_name: order?.shippingBranch || '-',
        client_name: order.clientName || '-',
        sub_total: order.subtotal,
        total: order.total,
      }));
      setRowData(newData);
    } catch (error) {
      console.error('Error fetching purchase orders:', error);
    }
  };

  const getTopItemsByAmount = async () => {
    try {
      setTopItemsLoading(true);



      const body = {
        page: 1,
        limit: 5,
        sortOrder: 'desc',
        sortBy: 'grandTotal',
        clientId: user?.userType === 'client' ? user?.clientId : '',
        startDate: date.start,
        branchId:selectedBranche,
        warehouseId:selectedWarehouses,
        endDate: date.end,
      };

      const res = await getItemPOList(body);

      if (res?.success && Array.isArray(res.payload?.data)) {
        const sorted = [...res.payload.data].sort(
          (a, b) => Number(b.grandTotal || 0) - Number(a.grandTotal || 0)
        );
        setTopItems(sorted.slice(0, 5));
      } else {
        setTopItems([]);
      }
    } catch (error) {
      console.error('Error fetching top items:', error);
      setTopItems([]);
    } finally {
      setTopItemsLoading(false);
    }
  };

  const handleCopyOrder = async (id) => {
    try {
      navigate(`/purchase-requisitions/${id}/copy`);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    props.setBreadcrumbItems('Dashboard', breadcrumbItems);
    searchClient(user.clientId);
  }, [user.clientId]);


  useEffect(() => {
    getPurchaseOrderListData();
    getPurchaseOrderStatusList();
    getTopItemsByAmount();
  }, [user.clientId, date, selectedWarehouses,selectedBranche]);

  return (
    <React.Fragment>
      <div className="m-4">
        <DateFilter
          onDateChange={onDateChange}
          initialValue={defaultDateRange.current}
        />
      </div>

      <Row className="g-4 align-items-stretch">

        <Col xl="7" lg="7" md="12" className="d-flex">
          <div style={{ flex: 1, display: "flex",alignItems: "center",justifyContent: "center" }}>
            <Miniwidget
              reports={chipData}
              style={{ flex: 1, height: "auto", }}
            />
          </div>
        </Col>

        <Col xl="5" lg="5" md="12" className="d-flex">
          <Card style={{ flex: 1, height: "auto" }}>
            <CardBody className="h-100 d-flex flex-column">
              <h5 className="mb-3">Top 5 Items</h5>

              {
                topItemsLoading ? (
                  <div>Loading...</div>
                ) : topItems.length === 0 ? (
                  <div>No data available</div>
                ) : (
                  <table className="top-items-table w-100">
                    <tbody>
                      {topItems.map((item) => (
                        <tr key={item.itemId}>
                          <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
                            <td>{item.itemName || "-"}</td>
                          </RequireUserType>
                          <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
                            <td>{item.alternateItemTitle || "-"}</td>
                          </RequireUserType>
                          <td style={{ textAlign: "right" }}>
                            <AmountCell value={item.grandTotal} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )
              }
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col xl="12">
          <Card>
            <CardBody>
              <OrderGraph />
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row className="g-4 align-items-stretch">

        <Col xl="6" md="12" className="d-flex">
          <Card className="w-100 h-100">
            <CardBody className="d-flex flex-column h-100">
              <h4 className="mb-4">Recent Orders</h4>

              {rowData.length === 0 ? (
                <div>No recent orders</div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table className="w-100" style={{ minWidth: "800px" }}>

                    {/* HEADER */}
                    <thead >
                      <tr style={{ fontSize: "13px", color: "#6B6B6B", padding: "20px", textAlign: "center" }}>
                        <th>Order</th>
                        <th>Date</th>
                        <th>Status</th>
                        <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
                          <th>Customer Name</th>
                        </RequireUserType>
                        <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
                          <th>Approved Date</th>
                          </RequireUserType>
                        <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
                          <th>Warehouse</th>
                        </RequireUserType>
                        <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
                         <th>Branch</th>
                        </RequireUserType>
                        <th>Sub Total</th>
                        <th>Amount</th>
                      </tr>
                    </thead>

                    {/* BODY */}
                    <tbody>
                      {rowData.map((item) => (
                          <tr
                            key={item.order_id}
                            style={{
                              borderTop: "1px solid #eee",
                              cursor: "pointer",
                              textAlign: "center",
                            }}
                            onClick={() =>
                              navigate(`/purchase-orders/${item.order_id}`)
                            }
                          >
                            <td style={{ fontWeight: 500, padding: "10px 0" }}>
                              {item.order_number}
                            </td>

                            <td style={{ padding: "10px 10px" }}>
                              {item.createdAt}
                            </td>

                            <td style={{ padding: "10px 10px" }}>
                              <OrderStatusRenderer value={item.order_status} />
                            </td>

                            <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
                              <td style={{ padding: "10px 10px" }}>
                              {item.client_name}
                            </td>
                            </RequireUserType>

                            <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
                              <td style={{ padding: "10px 10px" }}>
                              {item.approvedAt}
                            </td>
                            </RequireUserType>
                            <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
                              <td style={{ padding: "10px 10px" }}>
                              {item.Warehouse_name}
                            </td>
                            </RequireUserType>
                            
                            <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
                              <td style={{ padding: "10px 10px" }}>
                              {item.branch_name}
                            </td>
                            </RequireUserType>

                            <td style={{ padding: "10px 10px" }}>
                              <AmountCell value={item.sub_total} />
                            </td>

                            <td style={{ padding: "10px 10px" }}>
                              <AmountCell value={item.total} />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
        <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>

          <Col xl="6" md="12" className="d-flex" style={{ height: "50vh" }} >
            <Card className="w-100 h-100 overflow-y-scroll">
              <CardBody className="d-flex flex-column h-100">
                <h4 className="mb-3">Favourite Orders</h4>

                {favourites.length === 0 ? (
                  <div>No favourite orders yet</div>
                ) : (
                  <table className="top-items-table w-100">
                    <thead>
                      <tr style={{ fontSize: "14px", color: "#000" }}>
                        <th style={{ textAlign: "left", paddingBottom: "8px" }}>
                          PR No.
                        </th>
                        <th style={{ textAlign: "center", paddingBottom: "8px" }}>
                          Total Amount
                        </th>
                        <th style={{ textAlign: "right", paddingBottom: "8px" }}>
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {favourites.map((item) => (
                        <tr key={item.id} style={{ cursor: "default" }}>
                          <td
                            onClick={() => handleCopyOrder(item?.purchaseOrder?._id)}
                            style={{ cursor: "pointer", color: "#0d6efd", textDecoration: "underline" }}
                          >
                            {item?.purchaseOrder?.purchaseRequisitionNumber || "--"}
                          </td>

                          <td style={{ textAlign: "center" }}>
                            <AmountCell value={item?.purchaseOrder?.grandTotal} />
                          </td>

                          <td style={{ textAlign: "right", position: "relative" }}>
                            <div
                              onClick={() => toggleOptionsMenu(item?.purchaseOrder?._id)}
                              style={{ cursor: "pointer", display: "inline-block" }}
                            >
                              <MoreVert />
                            </div>

                            {openMenuId === item?.purchaseOrder?._id && (
                              <>
                                <div
                                  className="menu-backdrop"
                                  onClick={() => toggleOptionsMenu(null)}
                                />

                                <div className="options-menu">
                                  <div
                                    className="options-menu-item"
                                    onClick={() => handleCopyOrder(item?.purchaseOrder?._id)}
                                  >
                                    Copy
                                  </div>
                                  <div
                                    className="options-menu-item delete"
                                    onClick={() => handleDeleteFromFavorites(item?.purchaseOrder?._id)}
                                  >
                                    Delete
                                  </div>
                                </div>
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </CardBody>
            </Card>
          </Col>
        </RequireUserType>

      </Row>

    </React.Fragment>
  );
}

export default connect(null, { setBreadcrumbItems })(Dashboard);
